import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../services/shared.service";
import { verifyAccountsV2 } from "../../models/request/shareReq";
import { ErrorHandlers } from "../../../core/helpers/errorhandlers";
import { Notification } from "../../../core/helpers/notification";

@Component({
  selector: "app-utility",
  template: ` <p>utility works!</p> `,
  styleUrls: [],
})
export class UtilityComponent implements OnInit {
  constructor(
    private shareservice: SharedService,
    private errorhandler: ErrorHandlers,
    private notservice: Notification
  ) {}

  ngOnInit() {}

  //account verification
  verifyAccount = (Details) => {
    this.shareservice.accountVerificationv2(Details).subscribe(
      (data) => {
        return data;
      },
      (error) => {}
    );
  };
}
